"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MapPin = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const MapPin = ({ style: styleOverrides = {}, size, className = "", }) => {
    const cssStyle = size !== null && size !== void 0 ? size : "100%";
    const coreStyle = {
        display: "inlineBlock",
        width: cssStyle,
        height: cssStyle,
    };
    const style = Object.assign(Object.assign({}, coreStyle), styleOverrides);
    return ((0, jsx_runtime_1.jsx)("svg", Object.assign({ id: "map-pin", viewBox: "0 0 42 54", className: `${className}`, style: style }, { children: (0, jsx_runtime_1.jsx)("g", Object.assign({ id: "map-pin", viewBox: "0 0 42 54", xmlns: "http://www.w3.org/2000/svg" }, { children: (0, jsx_runtime_1.jsx)("path", { d: "M21.5 1A19.67 19.67 0 0 0 5 9.73a18.24 18.24 0 0 0-1.17 18.1c.4.756.854 1.48 1.36 2.17l15.65 22.66a.81.81 0 0 0 1.32 0l15.52-22.47a18.81 18.81 0 0 0 1.53-2.51 18.26 18.26 0 0 0-1.29-18A19.67 19.67 0 0 0 21.5 1z", fill: "#909AB5", stroke: "#FFF", strokeWidth: "2" }) })) })));
};
exports.MapPin = MapPin;
